import LocalDataProxy from 'main/components/tables/interactive/state/data_proxy/LocalDataProxy';
import AsyncDataProxy from 'main/components/tables/interactive/state/data_proxy/AsyncDataProxy';
import ProxyDescriptor from 'main/components/tables/interactive/state/data_proxy/ProxyDescriptor';

function createDataProxy(proxyDescriptor) {
  const descriptor = new ProxyDescriptor(proxyDescriptor);
  switch (descriptor.type) {
    case 'local':
      return new LocalDataProxy(proxyDescriptor);
    case 'async':
      return new AsyncDataProxy(proxyDescriptor);
    default:
      throw new Error(`Proxy type ${proxyDescriptor.type} is not supported.`);
  }
}

export default createDataProxy;
